import type { ReactNode, ReactElement } from "react";
import { Tooltip as BaseTooltip } from "@base-ui/react/tooltip";
import styles from "./Tooltip.module.css";

type TooltipSide = "top" | "right" | "bottom" | "left";

interface TooltipProps {
  readonly children: ReactElement;
  readonly content: ReactNode;
  readonly side?: TooltipSide;
  readonly delay?: number;
}

export function Tooltip({ children, content, side = "top", delay }: TooltipProps) {
  return (
    <BaseTooltip.Root>
      <BaseTooltip.Trigger render={children} delay={delay} />
      <BaseTooltip.Portal>
        <BaseTooltip.Positioner side={side} sideOffset={6}>
          <BaseTooltip.Popup className={styles.popup}>
            {content}
          </BaseTooltip.Popup>
        </BaseTooltip.Positioner>
      </BaseTooltip.Portal>
    </BaseTooltip.Root>
  );
}
